// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonLink_root__DDv00","button":"ButtonLink_button__fhj1T"};